export enum ProcessingState {
  NOT_PROCESSED = "NOT_PROCESSED",
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
}